import { create } from 'zustand'

const TOAST_TTL_MS = 4000

export const useToastStore = create((set, get) => ({
  toasts: [],

  addToast: ({ message, type = 'info' }) => {
    const id = typeof crypto !== 'undefined' && crypto.randomUUID
      ? crypto.randomUUID()
      : `toast-${Date.now()}-${Math.random().toString(36).slice(2)}`
    const toast = { id, message, type }
    set((state) => ({ toasts: [...state.toasts, toast] }))
    setTimeout(() => {
      get().removeToast(id)
    }, TOAST_TTL_MS)
  },

  removeToast: (id) => {
    set((state) => ({ toasts: state.toasts.filter((t) => t.id !== id) }))
  },
}))
